import { useMemo } from "react";

// A cross-model Paste Task lands its row via a flow entirely outside this
// table's own selection/bulk-action state, so its "just changed" tint is fed
// in from the parent rather than tracked by useModelTaskBulkActions.
const useMergedChangedIds = (bulkChangedIds, externalChangedIds) =>
	useMemo(() => {
		if (!externalChangedIds?.size) return bulkChangedIds;
		return new Set([...bulkChangedIds, ...externalChangedIds]);
	}, [bulkChangedIds, externalChangedIds]);

export default useMergedChangedIds;
